import React from "react";

const OverviewGrid = ({ overview = [] }) => (
  <div className="grid two">
    {overview.map((item) => (
      <div key={item.label} className="panel" style={{ minHeight: 80 }}>
        <div className="card-title">{item.label}</div>
        <div style={{ fontWeight: 700, fontSize: 18 }}>{item.value}</div>
      </div>
    ))}
  </div>
);

export default OverviewGrid;
